
import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
@Component({
  name: "TitleHeader",
  components: {},
})
export default class TitleHeader extends Vue {
  @Prop({ type: Array, required: false }) btnList?: any;
  @Prop({ type: Number, default: null }) active: any;
  @Prop({ type: Boolean, default: true }) btn?: any;
  @Prop({ type: Boolean, default: false }) searchBtn?: any;
  handleClickBtn(index: any) {
    this.$emit("handleClickBtn", index);
  }
  handleClickMore() {
    this.$emit("handleClickMore");
  }
}
